const Footer = () => {
    return (
        <>
        <footer className="bg-white/75 mt-6 mb-1">
        <p>Author: Dericioso © 2022 All right reserved</p>
        <a href="mailto:dery.lantigua@gmail.com">Email me</a>
        </footer>
        </>
    )
}

export default Footer